import React from "react";

export default function ScrollBlock({isVisible}) {

    return (
        isVisible && <div className="scroll-icon"/>
    )
}